exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nivel[data-v-5fbd4dab]{margin-top:1.2rem;width:100%;background-color:#fff;display:inline-block;text-align:center;padding:.5rem 0\n}\n.nivel .nivel-number[data-v-5fbd4dab]{font-size:2.5rem;font-weight:bold;display:block;line-height:1\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fbd4dab","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TrainerLevel.vue
// module id = gQqU
// module chunks = 1